module.exports = __webpack_public_path__ + "assets/img/office-building-szepvolgyi-1920.bb3fefa4.webp";